<template>
	<v-text-field
		:modelValue="modelValue"
		:label="label"
		:placeholder="placeholder"
		:hint="hint"
		:variant="variant"
		:hideDetails="hideDetails"
		:disabled="disabled || readonly"
		:clearable="clearable"
		:density="density"
		:counter="counter"
		:color="color"
		:prefix="prefix"
		:suffix="suffix"
		:autofocus="autofocus"
		:error="error"
		:error-messages="errorMessages"
		class="ao-text-field"
		:class="[sizeClass, readonly ? 'ao-text-field--readonly' : '']"
		@update:modelValue="$emit('update:modelValue', $event)"
		@update:focused="onFocusedChange"
	>
		<template v-slot:prepend-inner>
			<slot name="prepend-inner"/>
		</template>
		<template v-slot:append-inner>
			<slot name="append-inner"/>
		</template>
	</v-text-field>
</template>

<script>
export default {
	name: 'AoTextField',

	components: {},

	props: {

		modelValue: {
			type: [String, Number],
		},

		label: {
			type: String,
		},

		placeholder: {
			type: String,
		},

		hint: {
			type: String,
		},

		variant: {
			type: String,
			// default: 'outlined',
		},

		hideDetails: {
			type: [Boolean, String],
			default: false,
			validator: (value) => ([true, false, 'auto'].includes(value)),
		},

		disabled: {
			type: Boolean,
			default: false,
		},

		readonly: {
			type: Boolean,
			default: false,
		},

		clearable: {
			type: Boolean,
			default: false,
		},

		density: {
			type: String,
			default: 'default',
			validator: (value) => (['default', 'comfortable', 'compact'].includes(value)),
		},

		counter: {
			type: [Boolean, Number],
			default: false,
			validator: (value) => ([true, false].includes(value) || (typeof value === 'number')),
		},

		color: {
			type: String,
			default: 'primary'
		},

		prefix: {
			type: String,
		},

		suffix: {
			type: String,
		},

		error: {
			type: Boolean,
			default: false,
		},

		errorMessages: {
			type: [String, Array],
			default: () => ([]),
		},

		size: {
			type: String,
			default: null,
			validator: (value) => (['small', 'x-small'].includes(value)),
		},
		autofocus: {
			type: Boolean,
			default: false,
		},

	},

	emits: {
		'update:modelValue': null,
		focus: null,
		blur: null,
	},

	computed: {
		sizeClass() {
			let prefix = 'ao-custom-text-field-'
			let size = ''
			if (this.size) {
				size = prefix + this.size
			}
			return size
		},
	},

	methods: {
		onFocusedChange(value) {
			if (value) {
				this.$emit('focus')
			} else {
				this.$emit('blur')
			}
		},
	},
}
</script>

<style lang="scss">
.not-blur-disabled {
	.v-field--disabled {
		opacity: 1;
		border-bottom: 1px solid rgb(var(--v-theme-textSecondary));
		.v-field__outline::before {
			opacity: 0;
		}
	}
}
.ao-text-field {
	font-family: Inter;
	input {
		font-size: 0.875em;
		font-weight: 400;
	}
	.v-field {
		padding: 2px 0;
	}
	.v-field__input {
		padding-inline-start: 0;
		min-height: unset;
	}
	.v-field__clearable {
		i {
			font-size: 0.81em;
			width: 16px;
			height: 16px;
		}
		background: rgba(15, 24, 34, 0.05);
		border-radius: 50%;
		width: 16px;
		height: 16px;
		padding: 0;
		margin-top: 26px;
	}

	&.ao-text-field--readonly {
		--v-disabled-opacity: 1 !important;

		.v-field {

			&.v-field--error {

				.v-label.v-field-label {
					color: rgb(var(--v-theme-error));
				}

			}

			&.v-field--variant-underlined {

				.v-field__outline::before {
					border-style: solid;
					border-image: unset;
				}

			}

			&.v-field--disabled {
				opacity: unset;
			}

		}

		.v-input__details {

			.v-messages {
				color: rgb(var(--v-theme-error));
			}

		}

	}

	.v-text-field__ {

		&prefix,
		&suffix {
			line-height: 1.2;
			min-height: unset;
			font-size: 14px;
			align-self: end;
		}

	}

	&.ao-custom-text-field-small {
		&.v-text-field input {
			font-size: 0.75em;
			font-weight: 400;
		}
	}
	&.ao-custom-text-field-x-small {
		&.v-text-field input {
			font-size: 0.625em;
			font-weight: 400;
		}
		.v-field__clearable {
			margin-top: 10px;
		}
		.v-field__prepend-inner {
			align-items: center;
		}
	}
}
</style>
